export const PORTAL_LAST_ENTID_STORAGE_KEY = '@metropolis/portal:last-used-enterpriseId';
